import { useLanguage } from "../i18n/LanguageContext";
import { WorkCard } from "./WorkCard";

export default function Work() {
  const { t, lang } = useLanguage();
  const items = t("work.items") || [];

  return (
    <section id="work" data-testid="work-section" className="py-24 md:py-36 bg-[#F7F5F0]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 md:col-span-8">
            <div className="eyebrow text-ink mb-4">{t("work.overline")} · 06</div>
            <h2 className="heading-display text-5xl md:text-6xl lg:text-7xl" data-testid="work-title">
              {t("work.title")}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 md:gap-8">
          {items.map((item, i) => (
            <WorkCard key={item.slug} item={item} lang={lang} visitLabel={t("work.visit")} testid={`work-item-${i}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
